import searchCampaigns from '@/core/_search'
import queries from '../../../core/queries'
import { computed } from '@vue/composition-api'
import useStore from '@/core/hooks/useStore'

const useMostBackedCamps = () => {
    const { state } = useStore()
    searchCampaigns(queries.mostBacked)
    const data = computed(() => state.value.searchResults.sort((a,b) => b.backers - a.backers))
    return {
        data
    }
}
export default useMostBackedCamps

